<div class="overflow-hidden bg-white shadow sm:rounded-lg max-w-7xl mx-auto">
  <div class="px-4 py-6 sm:px-6">
    <h3 class="font-semibold text-lg text-gray-900">Profil</h3>
  </div>
  <div class="border-t border-gray-300">
    <dl class="divide-y divide-gray-300">
      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-gray-900 fw-bold">Benutzername</dt>
        <dd
          class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ AuthenticationService.userValue?.name }}
        </dd>
      </div>
      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-gray-900 fw-bold">Unternehmen</dt>
        <dd
          class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ AuthenticationService.userValue?.company?.name }}
        </dd>
        <dt class="text-sm font-medium text-gray-900 fw-bold">Standort</dt>
        <dd
          class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ AuthenticationService.userValue?.shard?.name }}
        </dd>
      </div>
      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-gray-900 fw-bold">Rollen</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
          <p>
            @for (role of AuthenticationService.userValue?.permissions; track role; let last = $last) {
              <span>{{ role }}{{ !last ? ", " : "" }}</span>
            }
          </p>
        </dd>
      </div>
      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        @if (AuthenticationService.isExternalSession) {
          <!-- external session: password is managed at the provider -->
          <dt class="text-sm font-medium leading-6 text-gray-900 fw-bold">Passwort</dt>
          <dd class="mt-2 text-sm text-gray-700 sm:col-span-2 sm:mt-0 space-y-2">
            <p>Dieses Konto meldet sich über <strong>{{ providerName }}</strong> an. Das Passwort wird bei
              {{ providerName }} verwaltet und kann hier nicht geändert werden.</p>
            @if (providerAccountUrl) {
              <a [href]="providerAccountUrl" target="_blank" rel="noopener noreferrer"
                 class="inline-flex items-center gap-1 font-semibold text-theme-primary-700 hover:text-theme-primary-900">
                Passwort bei {{ providerName }} verwalten ↗
              </a>
            }
          </dd>
        } @else {
          <!-- local session: in-app password change -->
          <div>
            <dt class="text-sm font-medium leading-6 text-gray-900 fw-bold">Sicherheit</dt>
            <div class="grid grid-cols-1 text-gray-500">
              <p class="mt-2 text-sm text-gray-500 inline-flex">
                <app-cross-check-display [Valid]="CheckUpper()" [Text]="'Großbuchstabe'" [IconSide]="Side.Left"/>
              </p>
              <p class="mt-2 text-sm text-gray-500">
                <app-cross-check-display class="" [Valid]="CheckLower()" [Text]="'Kleinbuchstabe'"
                                         [IconSide]="Side.Left"/>
              </p>
              <p class="mt-2 text-sm text-gray-500">
                <app-cross-check-display [Valid]="CheckNumbers()" [Text]="'Zahl'" [IconSide]="Side.Left"/>
              </p>
              <p class="mt-2 text-sm text-gray-500">
                <app-cross-check-display class="" [Valid]="CheckSpecial()" [Text]="'Sonderzeichen:&nbsp;!@#$&*'"
                                         [IconSide]="Side.Left"/>
              </p>
              <p class="mt-2 text-sm text-gray-500">
                <app-cross-check-display [Valid]="CheckLength()" [Text]="'8-32&nbsp;Zeichen'" [IconSide]="Side.Left"/>
              </p>
            </div>
          </div>
          <dd class="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
            <form class="space-y-6" name="password-change">
              <div class="relative -space-y-px rounded-md shadow-sm">
                <div class="pointer-events-none absolute inset-0 z-10 rounded-md ring-1 ring-inset ring-gray-300"></div>
                <div>
                  <label for="old_password" class="sr-only">Altes Passwort</label>
                  <input [(ngModel)]="old" name="old_password" id="old_password" type="password"
                         autocomplete="current-password" required
                         class="px-3 relative block w-full rounded-t-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 focus:z-10 sm:text-sm sm:leading-6"
                         placeholder="Altes Passwort">
                </div>
                <div>
                  <label for="new_password" class="sr-only">Passwort</label>
                  <input (change)="Validate()" [(ngModel)]="password" name="new_password" id="new_password"
                         type="password"
                         autocomplete="new-password" required
                         class="px-3 relative block w-full border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 focus:z-10 sm:text-sm sm:leading-6"
                         placeholder="Neues Passwort">
                </div>
                <div>
                  <label for="repeat_password" class="sr-only">Passwort</label>
                  <input (change)="Validate()" [(ngModel)]="confirmation" id="repeat_password" name="repeat_password"
                         type="password"
                         autocomplete="new-password" required
                         class="px-3 relative block w-full rounded-b-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 focus:z-10 sm:text-sm sm:leading-6"
                         placeholder="Passwort wiederholen">
                </div>
              </div>

              <div>
                <button type="submit"
                        class="flex w-full justify-center rounded-md bg-theme-primary-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700"
                        name="submit"
                        [ngClass]="{'!pointer-events-none !bg-gray-200 !text-gray-800': !Validate()}" (click)="change()">
                  Passwort aktualisieren
                </button>
              </div>
            </form>
          </dd>
        }
      </div>

      <!-- Linking section. Local session: manage own authenticators + password toggle.
           External session: list/unlink the local accounts this identity is linked to. -->
      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm font-medium text-gray-900 fw-bold">
          {{ AuthenticationService.isExternalSession ? 'Verknüpfte Konten' : 'Anmeldung & Authentifizierung' }}
        </dt>

        <!-- external session: local accounts linked to this identity -->
        @if (AuthenticationService.isExternalSession) {
          <dd class="mt-2 sm:col-span-2 sm:mt-0">
            @if (linkedAccounts.length) {
              <ul class="divide-y divide-gray-200 rounded-md border border-gray-200">
                <!-- Tracked on kind + id: an employee id and a user id come from different databases and can
                     collide, and the payroll rows are keyed by company id. -->
                @for (a of linkedAccounts; track a.kind + ':' + a.id) {
                  <li class="flex flex-col gap-2 p-3 sm:flex-row sm:items-center sm:justify-between">
                    <span class="min-w-0">
                      <span class="block text-sm font-medium text-gray-900 truncate">{{ a.name }}</span>
                      @if (a.companyName) {
                        <span class="block text-xs text-gray-500">{{ a.companyName }}@if (a.shardName) {
                          <span> · {{ a.shardName }}</span>
                        }</span>
                      }
                    </span>
                    <!-- Only where it can do something. A payroll company is a role grant, not a bracket:
                         there is no link row to break, so the button would 404 whatever it called — taking
                         that access away is a revoke and belongs to the access screen. -->
                    @if (canUnlink(a)) {
                      <button type="button" (click)="unlinkAccount(a)"
                              class="self-start sm:self-auto rounded-md bg-red-50 px-3 py-1.5 text-sm font-medium text-red-600 hover:bg-red-100">
                        Trennen
                      </button>
                    } @else {
                      <span class="self-start sm:self-auto text-xs text-gray-500">
                        Über „Zugriffe“ verwalten
                      </span>
                    }
                  </li>
                }
              </ul>
            } @else {
              <p class="text-sm text-gray-500">Keine lokalen Konten verknüpft.</p>
            }
          </dd>
        }

        <!-- local session: own authenticators + password toggle -->
        @if (!AuthenticationService.isExternalSession && authenticators; as auth) {
          <dd class="mt-2 sm:col-span-2 sm:mt-0 space-y-4">
          <!-- linked authenticators -->
          <div>
            <p class="text-sm font-medium text-gray-700 mb-2">Externe Authentifizierung</p>
            @if (auth.authenticators.length) {
              <ul class="divide-y divide-gray-200 rounded-md border border-gray-200">
                @for (a of auth.authenticators; track a.id) {
                  <li class="flex flex-col gap-2 p-3 sm:flex-row sm:items-center sm:justify-between">
                    <span class="min-w-0">
                      <span class="block text-sm font-medium text-gray-900 truncate">{{ a.email || a.displayName || a.provider }}</span>
                      <span class="block text-xs text-gray-500">{{ a.provider }}</span>
                    </span>
                    <button type="button" (click)="removeAuthenticator(a.id)"
                            class="self-start sm:self-auto rounded-md bg-red-50 px-3 py-1.5 text-sm font-medium text-red-600 hover:bg-red-100">
                      Entfernen
                    </button>
                  </li>
                }
              </ul>
            } @else {
              <p class="text-sm text-gray-500">
                Keine externe Authentifizierung verknüpft.
              </p>
            }
            <!-- The four doors (#279), shared with the employee profile and the migration notice so the
                 three cannot drift apart again — this screen had three of them, the employee profile one, and
                 the notice's footer sent people to whichever they happened to hold. The component also owns
                 the claim-vs-link rule that used to live in this class.

                 returnUrl is pinned to the route rather than read off location: the profile can be reached
                 carrying ?claimed=success from a previous round trip, and handing that back to the provider
                 would re-announce a migration that already happened. -->
            <auth-account-link-options class="mt-3 block" idPrefix="profile-link" layout="inline"
                                       [returnUrl]="profileReturnUrl"
                                       (claimed)="onNativeClaimed()"
                                       (failed)="onLinkFailed($event)"/>
          </div>

          <!-- password-login toggle -->
          <div class="flex items-center justify-between gap-4 rounded-md border border-gray-200 p-3">
            <span class="min-w-0">
              <span id="password-login-label" class="block text-sm font-medium text-gray-900">Passwort-Login</span>
              <span id="password-login-hint" class="block text-xs text-gray-500">
                Kann nur deaktiviert werden, wenn mindestens eine externe Authentifizierung aktiv ist.
              </span>
            </span>
            <!-- The label wraps only the control and its track; the words sit in the sibling span above, so
                 without the explicit association this is announced as an unnamed checkbox. -->
            <label class="relative inline-flex cursor-pointer items-center">
              <input type="checkbox" class="peer sr-only" [checked]="auth.passwordLoginEnabled"
                     aria-labelledby="password-login-label" aria-describedby="password-login-hint"
                     (change)="togglePasswordLogin($any($event.target).checked)">
              <span class="h-6 w-11 rounded-full bg-gray-300 after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5 after:rounded-full after:bg-white after:transition-all peer-checked:bg-theme-primary-700 peer-checked:after:translate-x-5"></span>
            </label>
          </div>
          </dd>
        }
      </div>

      <!-- Zwei-Faktor-Authentifizierung (#282). Its own row beside "Anmeldung & Authentifizierung" rather than
           inside it: that block is about WHICH credential signs this account in (password, Microsoft, Apple,
           Google), this one is about an EXTRA factor on top of whichever it is.

           Local sessions only, and that is a real distinction rather than caution: a federated session already
           satisfies `AccountSecurityLevel.TwoFactor` (see the server enum), and its second factor — if any —
           belongs to the provider, not to us. Offering an authenticator here would be offering to protect a
           password this account does not have. -->
      @if (!AuthenticationService.isExternalSession) {
        <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-900 fw-bold">Zwei-Faktor-Authentifizierung</dt>
          <dd class="mt-2 sm:col-span-2 sm:mt-0">
            <app-two-factor-panel/>
          </dd>
        </div>
      }
    </dl>
  </div>
</div>

<div class="max-w-7xl mx-auto mt-6">
  <company-payroll-redeem/>
</div>
